import React, { Component } from 'react';
import { Modal, Button, Row, Col, Tabs, Tab, FormControl} from 'react-bootstrap';
import _ from 'lodash';
function searchingFor(term){ 
	return function(x){   
        return _.includes(x.label.toLowerCase(), term.toLowerCase()) || !term;
      }
    
	
}
export default class NCReasonsTemplate extends Component { 
  constructor(props){
    super(props)
    this.state={
      key:'NC Reason 1',
      totalSelected:props.selected,
      newSelected:[],
      deleteSelected:[],
      showFilter:false,
      term:'',
      NCReason1:props.selected.NCReason1,
      NCReason2:props.selected.NCReason2,
      NCReason3:props.selected.NCReason3,
      NCReason4:props.selected.NCReason4,
      NCReason5:props.selected.NCReason5,
    }
  } 
     UNSAFE_componentWillMount(){
        let totalObject = this.props.totalObjectNC['NC Reason 1']
        totalObject = _.orderBy(totalObject,['label'], ['asc'])
        let selected =  _.cloneDeep(this.props.selected['NC Reason 1object']) 
       this.setState({totalObject: _.cloneDeep(totalObject), selectedValues : selected ? selected :[]})
    }
    handleSelectedTotal = (e, obj) => {
      const{newSelected} = this.state
      if(e.target.checked){
        newSelected.push(obj)
      }  else {
        _.remove(newSelected, obj)
      }
      this.setState({newSelected})
    }
    handleCallBack = () =>{
      const {key, totalSelected, selectedValues} = this.state 
      totalSelected[key+'object'] = selectedValues
      this.setState({totalSelected})
      alert('Saved Successfully')
    }
    handleSelectedDelete = (e, obj) =>{     
      const{deleteSelected} = this.state
      if(e.target.checked){
        deleteSelected.push(obj)
      } else {
        _.remove(deleteSelected, obj)
      }
      this.setState({deleteSelected})
    }
    handleLeft = () =>{
      const{ selectedValues, deleteSelected, totalObject} = this.state
      _.map(deleteSelected, (del) =>{
        _.remove(selectedValues, del)
        totalObject.push(del)
      })      
      let ordered = _.orderBy(totalObject,['label'], ['asc'])
      this.setState({selectedValues, deleteSelected:[], totalObject:ordered})
    }
    handleRight = () =>{
      const {selectedValues, newSelected, totalObject} = this.state
      selectedValues.push(...newSelected)
      let inique = _.uniqBy(selectedValues, 'label')
      let object = _.pullAll(totalObject, newSelected)
      this.setState({selectedValues:inique, newSelected:[], totalObject:object})
    }
    handleDoubleLeft = () =>{
      let object = this.props.totalObjectNC[this.state.key]
      object = _.orderBy(object,['label'], ['asc'])
      this.setState({selectedValues:[], totalObject:object})
    }
    handleDoubleRight = () =>{      
      const {totalObject} = this.state
      this.setState({selectedValues:totalObject, totalObject:[]})
    }
    

    loadTabContent = (prop) => {
      this.setState({key:prop})      
      let totalObject = this.props.totalObjectNC[prop]
      totalObject = _.orderBy(totalObject,['label'], ['asc'])
      let selected =  this.props.selected[prop+'object'] 
      //selected = _.orderBy(selected,['label'], ['asc'])
      this.setState({totalObject: _.cloneDeep(totalObject), selectedValues : selected ? selected :[],term:'', showFilter:false,
        newSelected:[], deleteSelected:[]})
    }
    
    // handleSelected = () => {
    //   const {key, totalSelected, selectedValues} = this.state 
    //   totalSelected[key] = selectedValues
    //   this.setState({totalSelected})
    // }
    SelectFilter = () =>{
      this.setState((prevState) =>{
        return {showFilter: !prevState.showFilter};
      })
    }
    handleChange = (e) => {
      this.setState({term:e.target.value})	
    }
    handleCheckbox = (e) => {
      const {totalSelected, selectedValues} = this.state
      this.setState({[e.target.id]:e.target.checked})
      totalSelected[e.target.id] = e.target.checked;
      if(e.target.checked){
        totalSelected[e.target.name+'object'] = selectedValues
      }
      this.setState({totalSelected})
    }
    loadContent = (id, name) =>{
      const {totalObject, selectedValues, newSelected, showFilter, term, deleteSelected} = this.state
      return (
        <div style={{padding:'15px'}}>
          <p className='alignRight'><input checked={this.state[id] === true} name={name} onChange={this.handleCheckbox} id={id} type='checkbox'  /> &nbsp;{name}</p>
          <Row className='clearBoth selectedLabelRow'>            
            <Col className='align-self-center'><p><center><i class="fas fa-filter alignLeft" onClick={this.SelectFilter}></i><b>Available {name}</b></center></p>
            </Col>
            <Col md={1}></Col>
            <Col className='align-self-center'> <p><center><b>Selected {name}</b></center></p></Col>
          </Row>
        <Row>        
        <Col className='itempicker item-left'>        
        {showFilter === true ? 
        <FormControl
        placeholder="Search"
        aria-label="Search"
        aria-describedby="basic-addon1"
        id={"label"}
        onChange={(e) => this.handleChange(e)}
        value={term}
        />        
        : null}
        {_.map(totalObject.filter(searchingFor(term)), (obj) =>{
          let isSelected = _.some(newSelected, {'label':obj.label})
          return <label className={isSelected ? 'isSelectedItems avail' :' avail'}><input type='checkbox'  checked={isSelected}
          onClick={(e)=>this.handleSelectedTotal(e, obj)}/>{obj.label}</label>
        })
        }
        </Col> 
      <Col md={1} xs={2}>
        <p className='centerTop'>
         <i className='fas fa-angle-right centerIcon' onClick={this.handleRight}/>  
         <i className='fas fa-angle-left centerIcon' onClick={this.handleLeft}/>      
         <i className='fas fa-angle-double-right centerIcon' onClick={this.handleDoubleRight}/>
         <i className='fas fa-angle-double-left centerIcon' onClick={this.handleDoubleLeft}/>
         </p>   
      </Col>
      
      <Col  className='itempicker item-right'>     
      {_.map(selectedValues, (obj) =>{
           let isSelected = _.some(deleteSelected, {'label':obj.label})
          return <label className={isSelected ? 'isSelectedItems avail' :' avail'}><input type='checkbox'  checked={isSelected} 
          onClick={(e)=>this.handleSelectedDelete(e, obj)}/>{obj.label}</label>
        })
        }
      </Col>
      
    </Row>
     <Button className='alignRight' onClick={this.handleCallBack}> Save </Button> &nbsp; 
    </div>
        
      )
    }
    handleSave = () =>{
      this.props.onCallBack(this.state.totalSelected)
      this.props.closeModal()
    }


    render(){
      const{key} = this.state
      return(
      <Modal show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w"
      size='xl'
      aria-labelledby="contained-modal-title-vcenter"
      centered>     
      <Modal.Body>        
        <Tabs defaultActiveKey={key} transition={false} activeKey={key} unmountOnExit={true} id="noanim-tab-example" 
        onSelect={(eventKey)=>this.loadTabContent(eventKey)}>
            <Tab eventKey="NC Reason 1" title="NC Reason 1" key={1}>            
                {this.loadContent('NCReason1', "NC Reason 1")}
            </Tab>
            <Tab eventKey="NC Reason 2" title="NC Reason 2" key={2}>            
                {this.loadContent('NCReason2', "NC Reason 2")}
            </Tab>
            <Tab eventKey="NC Reason 3" title="NC Reason 3" key={3}>            
                {this.loadContent('NCReason3', "NC Reason 3")}
            </Tab>
            <Tab eventKey="NC Reason 4" title="NC Reason 4" key={4}>            
                {this.loadContent('NCReason4', "NC Reason 4")}
            </Tab>
            <Tab eventKey="NC Reason 5" title="NC Reason 5" key={5}>            
                {this.loadContent('NCReason5', "NC Reason 5")}
            </Tab>
        </Tabs>  
      </Modal.Body>
      <Modal.Footer>      
      <Button onClick={this.handleSave}> Save & Close </Button>
      <Button onClick={this.props.closeModal}> Discard Changes </Button>
      </Modal.Footer>
      </Modal>
      )
    }
    
 
}

  